// extracted by mini-css-extract-plugin
export default {"title":"ConfirmPassword_title__jrSNs","secondaryText":"ConfirmPassword_secondaryText__hnp-3","inputWithLabel":"ConfirmPassword_inputWithLabel__UKYob"};